import { create, StateCreator } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

const IS_DEV = import.meta.env.VITE_IS_DEV as boolean;

interface StoreConfig {
  localStorage?: boolean;
  version?: number;
  migrate?: (persistedState: unknown, version: number) => any;
  onRehydrateStorage?: (state: unknown) => void | ((state: unknown, error: unknown) => void);
  /** Переопределяет ключ localStorage (по умолчанию совпадает с name) */
  storageName?: string;
  /** Фильтрует поля, сохраняемые в localStorage */
  partialize?: (state: any) => any;
}

export const createStore = <T>(
  name: string,
  createState: StateCreator<T, [['zustand/immer', never]]>,
  config: StoreConfig = {},
) => {
  let state = immer(createState) as StateCreator<T>;

  if (IS_DEV) {
    state = devtools(state, { name }) as StateCreator<T>;
  }
  if (config.localStorage) {
    state = persist(state, {
      name: config.storageName ?? name,
      version: config.version,
      migrate: config.migrate,
      onRehydrateStorage: config.onRehydrateStorage,
      partialize: config.partialize,
    }) as StateCreator<T>;
  }

  return create<T>(state);
};
